module.exports = __webpack_public_path__ + "img/925.b7ca998b.gif";